import React, { useState, useMemo, useRef, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./email-template-list.scss";
import { BreadcrumbComponent } from "../../../common/components";
import CustomTabPanel from "./customized-template-tab-panel";
import EmailTemplateList from "./email-template-list";
import HeaderTab from "../header-tab/header-tab";
import FooterTab from "../footer-tab/footer-tab";
import { routes } from "../../../constants/routes";
import AddNewEmailTemplate from "./add-new-email-template";
import OptOutTab from "../opt-out-tab/opt-out-tab";
import { viewOpenProps } from "../email-letter-types";
import { useSetLoading } from "../../../common/hooks/appearance";
import LeadView from "../../leads/lead-view/lead-view";
import CustomerView from "../../customer/customer-view/customer-view";

const EmailTemplateTabs = () => {
  const [viewOpen, setViewOpen] = useState<viewOpenProps>({
    isOpen: false,
    mode: "view",
    template: null,
  });
  const breadcrumbLink = [
  {
    label: "Email Templates",
    link: routes.EMAILTEMPLATES,
    handleClick: (event: any) => {
      event.preventDefault();
      setViewOpen({ isOpen: false, mode: "view", template: null });
      setIndexValue(0);
      setCrumbMappingOption([
        {
          label: "Email Templates",
          link: routes.EMAILTEMPLATES,
          handleClick: (e: any) => {
            e.preventDefault();
            setViewOpen({ isOpen: false, mode: "view", template: null });
            setIndexValue(0);
            setCrumbMappingOption(breadcrumbLink); // reset breadcrumbs
          },
        },
      ]);
    },
  },
];

  const [crumbMappingOption, setCrumbMappingOption] =
    useState<any>(breadcrumbLink);
  const [indexValue, setIndexValue] = useState(0);
  const [isShowCreateTemplate, setShowCreateTemplateOpen] =
    useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [addNewTemplateBreadcrumb, setAddNewTemplateBreadcrumb] = useState<any>([
    {
      label: "Email Templates",
      link: routes.EMAILTEMPLATES,
      handleClick: (event: any) => {
        event.preventDefault();
        setShowCreateTemplateOpen?.(false);
      },
    },
    {
      label: "Add Email Template",
      link: "#",
    },
  ]);
  const tabNames = ["", "Header", "Footer", "Opt Out"];

const handleMainTabChange = (
  event: React.SyntheticEvent,
  newValue: number
) => {
  setIndexValue(newValue);
  const selectedTabName = tabNames[newValue];

  if (selectedTabName) {
    setCrumbMappingOption([
      ...breadcrumbLink,
      {
        label: selectedTabName,
        link: "#",
        handleClick: (event: any) => {
          event.preventDefault();
        },
      },
    ]);
  } else {
    // Just show Email Template if first tab
    setCrumbMappingOption([...breadcrumbLink]);
  }
};


const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
const [selectedUserType, setSelectedUserType] = useState<string>("");
const [selectedUserName, setSelectedUserName] = useState<string>("");
useEffect(() => {
  const selectedTabName = tabNames[indexValue];
  if (selectedTabName) {
    setCrumbMappingOption([
      ...breadcrumbLink,
      {
        label: selectedTabName,
        link: "#",
        handleClick: (event: any) => {
          event.preventDefault();
        },
      },
    ]);
  } else {
    setCrumbMappingOption([...breadcrumbLink]);
  }
}, []);

  const handleNameUpdate = (newName: string) => {
    console.log("Name updated:", newName);
    setSelectedUserName(newName);
    setCrumbMappingOption((prev: any) => {
      const updated = [...prev];
      updated[2] = { ...updated[2], label: newName };
      return updated;
    });
  };

  const showLoading = useMemo(() => isLoading, [isLoading]);
  useSetLoading(showLoading);
  const shouldShowUserView = viewOpen.isOpen && selectedUserId;

  return (
    <>
      {isShowCreateTemplate && (
        <AddNewEmailTemplate
          isShowCreateTemplate={isShowCreateTemplate}
          setShowCreateTemplateOpen={setShowCreateTemplateOpen}
          addNewTemplateBreadcrumb={addNewTemplateBreadcrumb}
        />
      )}
      <div
        className="leadlist-wrapper email-templates-wrapper"
        style={{ display: isShowCreateTemplate || shouldShowUserView ? "none" : "block" }}
      >
        {!isShowCreateTemplate && (
          <div className="breadcrumb-wrapper">
            <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
          </div>
        )}

        {!viewOpen?.isOpen && (
          <div className="email-template-tab-section">
            <Box>
              <Tabs
                value={indexValue}
                onChange={handleMainTabChange}
                allowScrollButtonsMobile
                variant="scrollable"
              >
                <Tab label="Email Templates" />
                <Tab label="Header" />
                <Tab label="Footer" />
                <Tab label="Opt Out" />
              </Tabs>
            </Box>
          </div>
        )}
        <div>
          <CustomTabPanel value={indexValue} index={0}>
            <EmailTemplateList
              viewOpen={viewOpen}
              setViewOpen={setViewOpen}
              crumbMappingOption={crumbMappingOption}
              setCrumbMappingOption={setCrumbMappingOption}
              templateType="Email"
              isShowCreateTemplate={isShowCreateTemplate}
              setShowCreateTemplateOpen={setShowCreateTemplateOpen}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setAddNewTemplateBreadcrumb={setAddNewTemplateBreadcrumb}
              addNewTemplateBreadcrumb={addNewTemplateBreadcrumb}
            />
          </CustomTabPanel>
          <CustomTabPanel value={indexValue} index={1} isCampaigns={false}>
            <HeaderTab />
          </CustomTabPanel>
          <CustomTabPanel value={indexValue} index={2} isCampaigns={false}>
            <FooterTab />
          </CustomTabPanel>
          <CustomTabPanel value={indexValue} index={3} isCampaigns={false}>
            <OptOutTab
            setSelectedUserId={setSelectedUserId}
            setSelectedUserType={setSelectedUserType}
            setSelectedUserName={setSelectedUserName}
            setViewOpen={(val: boolean) => setViewOpen({ ...viewOpen, isOpen: val })}
            setCrumbMappingOption={setCrumbMappingOption}
            setIndexValue={setIndexValue}
          />
          </CustomTabPanel>
        </div>
      </div>

      {/* Lead or customer view for optout users */}
      {shouldShowUserView && (
        <div className="leadlist-wrapper">
          <div className="breadcrumb-wrapper">
            <BreadcrumbComponent breadcrumbLink={crumbMappingOption} />
          </div>
          {selectedUserType === "lead" && (
            <LeadView
              selectedLeadId={selectedUserId}
              setLoading={setIsLoading}
              onLeadNameUpdate={(newName: string) => {
                handleNameUpdate(newName);
              }}
              setViewTaskvalue={() => {}}
              viewTaskvalue={{ open: false, taskId: null }}
              setViewMeetingvalue={() => {}}
              viewMeetingvalue={{ open: false, meetingId: null }}
              setCrumbMappingOption={setCrumbMappingOption}
              setViewCallValue={() => {}}
              viewCallValue={{ open: false, callId: null }}
            />
          )}
          {selectedUserType === "customer" && (
            <CustomerView
              selectedCustomerId={selectedUserId}
              setLoading={setIsLoading}
              onCustomerNameUpdate={(newName: string) => {
                handleNameUpdate(newName);
              }}
              setViewTaskvalue={() => {}}
              viewTaskvalue={{ open: false, taskId: null }}
              setViewMeetingvalue={() => {}}
              viewMeetingvalue={{ open: false, meetingId: null }}
              setCrumbMappingOption={setCrumbMappingOption}
              setViewCallValue={() => {}}
              viewCallValue={{ open: false, callId: null }}
            />
          )}
        </div>
      )}
    </>
  );
};
export default EmailTemplateTabs;
